import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconFamilyRoom = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconFamilyRoom",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M20 5h-.94v3.75h-2.84V6.88h-.94v1.87h-2.81V6.88h-.94v1.87h-6.6v-.94H8.7v-.47c0-.77-.63-1.4-1.4-1.4H5.4q-.26 0-.47.08V5H4v15h.94v-1.87h6.6V20h.93v-1.87h2.81V20h.94v-1.87h2.84V20H20zm-.94 10.78h-2.84V11.1h2.84zm-3.78-4.69v1.41h-2.81v-1.4zm-2.81 2.35h2.81v2.34h-2.81zm-.94-2.35v4.7h-6.6v-.95H8.7v-.46a1.4 1.4 0 0 0-1.4-1.41H5.4q-.26 0-.47.08v-1.96z"
  })
}));
IconFamilyRoom.displayName = 'IconFamilyRoom';